import {Box, Link, Typography} from '@mui/material';
import {messages} from '@smartmixin/i18n';
import {useIntl} from 'react-intl';

/**
 * The public pages' footer (landing, help, legal): a hairline above, the
 * copyright and three links in caption type. The links wrap onto a second
 * line rather than widening the page (the German labels overflowed a phone
 * by 86px when the row could not wrap).
 */
export default function StickyFooter() {
  const {formatMessage} = useIntl();
  const links = [
    {href: '/help', label: formatMessage(messages.helpCenter.helpCenter)},
    {
      href: '/terms-and-conditions',
      label: formatMessage(messages.settings.termsOfService),
    },
    {
      href: '/privacy-policy',
      label: formatMessage(messages.settings.privacyPolicy),
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.default',
      }}>
      <Box
        sx={{
          maxWidth: 1120 + 48,
          mx: 'auto',
          px: {xs: 2, sm: 3},
          py: 3,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          columnGap: 3,
          rowGap: 1.5,
        }}>
        <Typography
          variant="caption"
          component="p"
          sx={{color: 'text.secondary', m: 0}}>
          {'Copyright © '}
          <Link color="inherit" href="/">
            SmartMixin
          </Link>{' '}
          {new Date().getFullYear()}
        </Typography>
        <Box
          component="ul"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: 3,
            rowGap: 1,
            m: 0,
            p: 0,
            listStyle: 'none',
          }}>
          {links.map((link) => (
            <Typography
              key={link.href}
              component="li"
              variant="caption"
              sx={{color: 'text.secondary'}}>
              <Link color="inherit" href={link.href}>
                {link.label}
              </Link>
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
